import React from "react";
import { visaList } from "../../Booking/bookingdata";
import planePng from "../../../../assets/PNG/Plain.png";

// ─── ICON ─────────────────────────────────────────────────────────────────────

export const IconPlane = () => (
  <img src={planePng} alt="Plane" style={{ width: "100%", height: "100%", objectFit: "contain" }} />
);

// ─── CTA CHECKPOINTS ──────────────────────────────────────────────────────────

export const CTA_CHECKPOINTS = [
  { title: " Lightning-fast processing",  desc: "Your visa application is processed within 24–48 hours — no long waits, no uncertainty." },
  { title: "100% secure & confidential", desc: "Your documents and personal data are encrypted end-to-end and never shared with third parties." },
  { title: "190+ Countries Covered",     desc: "We handle visa applications for virtually every destination worldwide, from tourist to business visas." },
  { title: "Expert Visa Consultants",    desc: "Each application is reviewed by a certified immigration specialist with 10+ years of experience." },
  { title: "Zero Paperwork Hassle",      desc: "We guide you through every document, checklist, and form — so nothing gets missed or rejected." },
  { title: "Customer Support",           desc: "Questions? Our team is always on standby via chat, call, or email" },
  { title: "98.7% Approval Rate",        desc: "Our meticulous review process means nearly every application we submit gets approved on the first try." },
  { title: "Transparent Pricing",        desc: "No hidden fees, no surprise charges. You see exactly what you pay before confirming — always." },
  { title: "Real-Time Status Tracking",  desc: "Follow your application status live with our tracking portal — know exactly where things stand." },
  { title: "Award-winning service",      desc: "Rated #1 visa consultancy in Asia for 3 consecutive years. Trusted by over 200,000 satisfied travellers." },
];

// ─── HERO FILTER OPTIONS ─────────────────────────────────────────────────────

export const POPULARITY_OPTIONS = [
  { value: "All", label: "All Popularity" },
  { value: "M.V", label: "Most Visited" },
  { value: "T.P", label: "Top Pick" },
  { value: "M.T", label: "Trending" },
  { value: "B.D", label: "Best Deal" },
  { value: "M.L", label: "Most Loved" },
];

// ─── HELPERS ──────────────────────────────────────────────────────────────────

export function getVisaIdForDestination(name) {
  const normalized = name.trim().toLowerCase();

  const exact = visaList.find(v => v.country.toLowerCase() === normalized);
  if (exact) return exact.id;

  const nameMap = {
    "united arab emirates": "uae",
    "united states":        "usa",
    "new zealand":          "new-zealand",
    "hong kong":            "hong-kong",
  };

  for (const [key, id] of Object.entries(nameMap)) {
    if (normalized.includes(key)) return id;
  }

  const fuzzy = visaList.find(v =>
    v.country.toLowerCase().includes(normalized) ||
    normalized.includes(v.country.toLowerCase())
  );
  if (fuzzy) return fuzzy.id;

  return "uae";
}

export function getTomorrow() {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().split("T")[0];
}

export function isWeekend(dateStr) {
  if (!dateStr) return false;
  const [year, month, day] = dateStr.split("-").map(Number);
  const d = new Date(year, month - 1, day);
  return d.getDay() === 0 || d.getDay() === 6;
}

export function nextWeekday(dateStr) {
  const date = new Date(dateStr);
  const day  = date.getDay();
  if (day === 6) date.setDate(date.getDate() + 2); // Saturday  Monday
  else if (day === 0) date.setDate(date.getDate() + 1); // Sunday  Monday
  return date.toISOString().split("T")[0];
}



// ─── CUSTOM HOOK ──────────────────────────────────────────────────────────────

export function useCardLimit() {
  const [limit, setLimit] = React.useState(16);

  React.useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      if (w <= 600)      setLimit(6);
      else if (w <= 991) setLimit(9);
      else               setLimit(16);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return limit;
}